/**
 * Helpers for seller-entered links (Länkar tab + per-facility booking link).
 *
 * Rules (kept in sync with the server-side check in
 * server/api-util/validateUrl.js): a link must parse as a URL, use the
 * https: protocol, and have a hostname. A bare domain the seller typed
 * ("example.com") is normalized to "https://example.com".
 */

// Prepend https:// when the seller typed a bare domain (no protocol), and
// trim surrounding whitespace. Returns '' for empty input.
export const normalizeUrl = value => {
  if (typeof value !== 'string') {
    return '';
  }
  const trimmed = value.trim();
  if (trimmed === '') {
    return '';
  }
  // Already has a protocol (http://, https://, ftp://, …) — leave it as is
  // so the validator below can reject non-https protocols.
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

// True when `value` (already normalized) is a valid https URL with a hostname.
export const isValidHttpsUrl = value => {
  if (typeof value !== 'string' || value.trim() === '') {
    return false;
  }
  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' && !!url.hostname;
  } catch (e) {
    return false;
  }
};
